import { Component, Emit } from 'vue-property-decorator' ;
import {FileManager, IFile} from '../attachment-manager';


@Component
class AttachmentDragAndDrop extends FileManager {
    dtDropZoneHovered: boolean
    fkEditIndex: number
    fkEditModel: string
    dtFiles?: IFile[]
    constructor(){
        super()
        this.dtDropZoneHovered= false
        this.dtFiles= []
        this.fkEditIndex= -1
        this.fkEditModel= ''
    }

    mounted() {
    }

    destroyed() {

    }

    get lblSetting(){
        return {
            ...require('@/locales/generic-labels').default,
            ...require('@/locales/document').default
        }
    }

    get uploadButtonText(){
        return this.$t(this.lblSetting.documentUploadFiles)
    }

    get coIcon(){
        const navImages = require.context('../../assets/icon/',false,/\.(png|svg)$/)
        return navImages(`./document_bleu.png`)
    }

    handleDropFiles(e:DragEvent){
        //alert("hi")
        e.preventDefault(); 
        let transfer= e.dataTransfer
        this.handleFiles(transfer.files)
        this.dtDropZoneHovered= false
    }

    handleDrapOver($event: Event){
        $event.preventDefault()
        this.dtDropZoneHovered= true
    }

    handleDragEnter($event: Event){
        $event.preventDefault()
        this.dtDropZoneHovered= true
    }

    handleDragLeave($event:Event){
        $event.preventDefault()
        this.dtDropZoneHovered= false
    }

    handleFiles(files: FileList){
        console.log('filo=',files)
        Array.from(files).forEach((file: File)=> {
            if(file.size >  ((1e+7) * 4)) return this.displaySnackBar(this.$t(this.lblSetting.documentTooBigFile, { name: file.name }))
            this.convertToBase64(file)
              .then(file64 => {
                  file64.onloadend= () => {
                        this.dtFiles= [
                            ...this.dtFiles,
                            {
                                name: file.name,
                                type: this.fileType(file.type),
                                file: file64.result
                            }
                        ]

                        this.$emit('input',this.dtFiles)
                  }
              })
        })
    }

    handleEditAttachment(index){
        this.fkEditIndex= index
        const  file_parts= this.dtFiles[index].name.split('.')
        this.fkEditModel= file_parts.slice(0,file_parts.length-1).join('')
    }

    handleUpdateAttachment(){
        if(!this.fkEditModel) return
        this.dtFiles = this.dtFiles.map((item,index)=>{
            if(index !== this.fkEditIndex) return item
            const file_parts= item.name.split('.')
            const extension= file_parts[file_parts.length-1]
            return {
                ...item,
                name: [this.fkEditModel,extension].join('.')
            }
        })

        this.fkEditIndex= -1
        this.$emit('input',this.dtFiles)
    }

    handleDeleteAttachment(index){
        this.dtFiles.splice(index,1)
        this.$emit('input',this.dtFiles)
    }

    handleUpload(){
        this.$emit('upload',this.dtFiles)
    }
}

export default AttachmentDragAndDrop


// WEBPACK FOOTER //
// ./src/components/attachment-drag-drop/index.ts